/* eslint-disable import/prefer-default-export */
export const footerLinks = {
  leftSide: [
    {
      href: '/future-students/programs/',
      text: 'Programs',
    },
    {
      attributes: {
        onClick: (e) => {
          e.preventDefault()
          window.location.href = '/about/accessibility-policy/'
        },
      },
      external: false,
      href: '/about/accessibility-policy/',
      notGatsbyLink: true,
      text: 'Accessibility',
    },
    {
      href: '/about/accreditation/',
      text: 'Accreditation',
    },
    {
      href: '/alumni/',
      text: 'Alumni Services',
    },
    {
      href: '/cares-act/',
      text: 'CARES Disclosure',
    },
    {
      href: '/students/commencement/',
      text: 'Commencement',
    },
    {
      href: '/contact-us/',
      text: 'Contact Us',
    },
    {
      href: '/covid-19/',
      text: 'COVID-19 Information',
    },
    {
      href: '/about/directory/',
      text: 'Directory',
    },
    {
      attributes: {
        rel: 'noopener noreferrer',
        target: '_blank',
      },
      external: true,
      href: 'http://www.umafanshop.com/',
      notGatsbyLink: true,
      text: 'Fan Shop',
    },
    {
      href: '/about/faq/',
      text: 'FAQ',
    },
    {
      attributes: {
        rel: 'noopener noreferrer',
        target: '_blank',
      },
      external: true,
      href: 'https://www.guidanceresources.com/groWeb/login/login.xhtml',
      notGatsbyLink: true,
      text: 'Guidance Resource Center',
    },
  ],
  rightSide: [
    {
      href: '/healthcare-career-guide',
      text: 'Healthcare Career Guide',
    },
    {
      href: '/hearthealth',
      text: 'Heart Health',
    },
    {
      href: '/student-information/',
      text: 'Policies & Disclosures',
    },
    {
      href: '/students/phishing',
      text: 'Phishing Information',
    },
    {
      attributes: {
        rel: 'noopener noreferrer',
        target: '_blank',
      },
      external: true,
      href: 'https://go.ultimatemedical.edu/refer/',
      notGatsbyLink: true,
      text: 'Refer a Friend',
    },
    {
      href: '/students/request-transcripts/',
      text: 'Request Transcripts',
    },
    {
      href: '/student-information/',
      text: 'School Catalog',
    },
    {
      href: '/about/social-communities/',
      text: 'Social Communities',
    },
    {
      href: '/about/suppliers/',
      text: 'Suppliers',
    },
    {
      attributes: {
        rel: 'noopener noreferrer',
        target: '_blank',
      },
      external: true,
      href: 'https://go.ultimatemedical.edu/uma-cares/',
      notGatsbyLink: true,
      text: 'UMA Cares',
    },
    {
      href: '/students/wellness-center/',
      text: 'Wellness Center',
    },
    {
      external: true,
      href: 'https://workatuma.com',
      notGatsbyLink: true,
      text: 'Work at UMA',
    },
  ],
}
